module.exports = __webpack_public_path__ + "static/media/tv.d3827ccb.png";